
import { commonContent } from './content/common';
import { homeContent } from './content/home';
import { aboutContent } from './content/about';
import { shopContent } from './content/shop';
import { goalsContent } from './content/goals';
import { contactContent } from './content/contact';
import { footerContent } from './content/footer';

export const SiteContent = {
  common: commonContent,
  home: homeContent,
  about: aboutContent,
  shop: shopContent,
  goals: goalsContent,
  contact: contactContent,
  footer: footerContent
};
